"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 520,
      "has-modal-card": "",
      "trap-focus": "",
      scroll: "keep"
    },
    on: {
      close: _vm.handleClose
    }
  }, [_c("form", {
    staticClass: "modal-card",
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? "Editar Cliente" : "Registrar Cliente") + "\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleClose
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("b-field", {
    attrs: {
      label: "Nome do cliente",
      "label-for": "customer-name"
    }
  }, [_c("b-input", {
    attrs: {
      id: "customer-name",
      placeholder: "Nome",
      maxlength: "150",
      required: ""
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "CPF/CNPJ",
      "label-for": "customer-document",
      message: "Somente números."
    }
  }, [_c("b-input", {
    attrs: {
      id: "customer-document",
      placeholder: "00000000000",
      maxlength: "14",
      inputmode: "numeric",
      pattern: "[0-9]*"
    },
    model: {
      value: _vm.form.cpfCnpj,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cpfCnpj", $$v);
      },
      expression: "form.cpfCnpj"
    }
  })], 1)], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "plant-nursery-primary-btn",
    attrs: {
      "native-type": "submit",
      type: "is-primary",
      loading: _vm.isSaving,
      disabled: _vm.isSaving
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? "Atualizar" : "Registrar") + "\n      ")]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-text"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n        Cancelar\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;